module.exports = __webpack_public_path__ + "img/undraw_Hire_re_gn5j.77dafac9.svg";